import React from "react";
import Section from "../components/Section";

const COLLECTED = [
  ["Device Identifier", "App functionality, analytics, push messaging", "On-device & analytics services"],
  ["App usage events", "Understanding feature engagement to improve the App", "Analytics services only"],
  ["Crash & diagnostic reports", "Detecting and fixing bugs", "Crash reporting services"],
  ["Push notification token", "Delivering in-app and push notifications", "Messaging service"],
  ["Food reviews & photos you submit", "Core app feature — displaying your reviews", "App servers"]
];

function InformationWeCollect() {
  return (
    <Section id="information-we-collect" icon="📋" title="Information We Collect">
      <h3>What we do NOT collect</h3>
      <ul>
        <li>Name, email address, phone number, or any contact details</li>
        <li>Passwords or authentication credentials</li>
        <li>Financial or payment information</li>
        <li>Social media profiles or linked accounts</li>
        <li>Precise GPS coordinates stored or transmitted off-device</li>
      </ul>

      <h3>What we do collect</h3>
      <table>
        <thead>
          <tr>
            <th>Data Type</th>
            <th>Purpose</th>
            <th>Stored</th>
          </tr>
        </thead>
        <tbody>
          {COLLECTED.map(([type, purpose, stored]) => (
            <tr key={type}>
              <td><strong>{type}</strong></td>
              <td>{purpose}</td>
              <td>{stored}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Section>
  );
}

export default InformationWeCollect;
